import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconSignature({
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M15.804 15.736c0-1.456 1.937-1.713 2.266-.3l.415 1.784c.066.28-.094.566-.356.637-.262.07-.527-.102-.593-.383l-.415-1.783c-.017-.074-.045-.102-.066-.116a.181.181 0 0 0-.122-.023.187.187 0 0 0-.114.054c-.017.018-.039.055-.039.13v1.633c0 .93-.988 1.462-1.681.904a2.996 2.996 0 0 0-2.668-.578l-.517.137a1.152 1.152 0 0 1-.297.04H9.988c-.27-.001-.488-.236-.488-.525 0-.29.219-.524.488-.525h1.63c.02 0 .04-.003.059-.008l.516-.138c1.21-.325 2.493-.047 3.492.757a.067.067 0 0 0 .038.016.075.075 0 0 0 .04-.008.082.082 0 0 0 .03-.029.08.08 0 0 0 .01-.043v-1.633zm-5.845-9.6a1.416 1.416 0 0 1 2.013-.365l2.912 2.108c.653.473.813 1.405.355 2.081l-3.546 5.236c-.128.19-.299.347-.496.457l-3.919 2.194c-.872.488-1.91-.263-1.764-1.277l.653-4.56c.033-.228.118-.447.246-.637L9.96 6.137zm1.46.45a.472.472 0 0 0-.671.122l-3.546 5.236a.51.51 0 0 0-.082.213l-.408 2.849 1.576 1.142 2.45-1.37a.493.493 0 0 0 .091-.067l.074-.086L14.45 9.39a.514.514 0 0 0-.045-.63l-.074-.065-2.912-2.108z"/>
        </svg>
    );
}

export default IconSignature;
